import { createReducer, on } from '@ngrx/store';
import { Action } from '@ngrx/store';
import { Exercice } from '../../model/exercice.model';
import { ExerciceList } from '../../model/exerciceList.model';
import * as ExerciseActions from '../actions/exercise.actions';

export interface ExercisesData {
    exercises: ExerciceList | null,
    selectedExercice: Exercice | null,
    loading: boolean
}

export const initialState:ExercisesData = {
    exercises: null,
    selectedExercice: null,
    loading: false,
};

const documentFormationReducer = createReducer(
    initialState,
    on(ExerciseActions.GetExercise, (state) => ({ ...state, loading: true })),
    on(ExerciseActions.GetExercisefromurl, (state) => ({ ...state, loading: true })),
    on(ExerciseActions.GetExerciseSuccess, (state, action) => ({ ...state, exercises: action.payload, loading: false })),
    on(ExerciseActions.GetExerciseFailure, (state) => ({ ...state, exercises: null, loading: false })),
    on(ExerciseActions.SetExercice, (state, action) => ({ ...state, selectedExercice: action.exercice, loading: false })),
);

export function reducer(state: ExercisesData | undefined, action: Action) {
    return documentFormationReducer(state, action);
}